import { http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    close_outsource_contract,
    outsource_contract_need_clear,
    outsource_contract_save_final_contract,
    outsource_contract_contract_revoke,
    outsource_contract_contract_sign,
    delete_outsource_contract,
    outsource_contract_sign_remind
 } = util.api || {}

export function closeContractApi(params) {
    return http.post(close_outsource_contract, params)
}
// outsource_contract_need_clear
export function changeOutsourceContractNeedClearApi(params) {
    return http.post(outsource_contract_need_clear, params)
}
// outsource_contract_save_final_contract
export function outsourceContractSaveFinalContractApi(params) {
    return http.post(outsource_contract_save_final_contract, params)
}
// outsource_contract_contract_revoke

export function outsourceContractRevokeApi(params) {
    return http.post(outsource_contract_contract_revoke, params)
}

// outsource_contract_contract_sign
export function outsourceContractSignApi(params) {
    return http.post(outsource_contract_contract_sign, params)
}

export function deleteOutsourceContractApi(params) {
    return http.post(delete_outsource_contract, params)
}
export function outsourceContractSignRemindApi(params) {
    return http.post(outsource_contract_sign_remind, params)
}